import { render } from "./EmailNotVerified.vue?vue&type=template&id=173f15de"
import script from "./EmailNotVerified.vue?vue&type=script&lang=js"
export * from "./EmailNotVerified.vue?vue&type=script&lang=js"
script.render = render

export default script